import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import TimerScreen from './TimerScreen';
import Team1 from './Team1.js';  
import Team2 from './Team2.js';  
import Team3 from './Team3.js';  
import Team4 from './Team4.js';  
import Team5 from './Team5.js';  
import Team6 from './Team6.js';  
import Team7 from './Team7.js';  
import AllTeams from './AllTeams'; 

const App = () => {
  return (
    <Router>
      <Routes>
      {/* <Route path="/" element={<TimerScreen />} /> */}
        <Route path="/NAsQfU2I9YJQ4eJVfzsop" element={
            <TimerScreen>
              <Team1 />
            </TimerScreen>
          } />
        <Route path="/LGnFkxUDxqJ9EY8pANtYj" element={
            <TimerScreen>
              <Team2 />
            </TimerScreen>
          } />
        <Route path="/NQU2fI9YJQ4eJVfzsH7z9e" element={
            <TimerScreen>
              <Team3 />
            </TimerScreen>
          } />
        <Route path="/GLndFkxUsDxqJ9EY8pANtZ" element={
            <TimerScreen>
              <Team4 />
            </TimerScreen>
          } />
        <Route path="/Zamads099sdNtYjQAbcUya" element={
            <TimerScreen>
              <Team5 />
            </TimerScreen>
          } />
        <Route path="/tNQU2I9YJQ4eJVfzsH7z9iF" element={
            <TimerScreen>
              <Team6 />
            </TimerScreen>
          } />
        <Route path="/NQU2dI9YJQ4eJVfzsH7zoK9" element={
            <TimerScreen>
              <Team7 />
            </TimerScreen>
          } />
        <Route path="/all-teams" element={<AllTeams />} />
      </Routes>
    </Router>
  );
};

export default App;
